export default __webpack_public_path__ + "static/media/img.8b9dc2cc.svg";